import { Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions } from 'ag-grid-community';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FCToasterService } from '../../common/toaster/FCToasterService';
import { Service } from '../../service';

@Component({
    selector: 'app-xml-process-status',
    templateUrl: './xml-process-status.component.html',
    styleUrls: ['./xml-process-status.component.scss'],
    standalone: false
})
export class XmlProcessStatusComponent implements OnInit {
  @ViewChild("agGridXmlProcessStatus", { static: false }) agGridXmlProcessStatus!: AgGridAngular;
  gridOptions!: GridOptions;
  rowData!: any[];
  columnDefs!: any[];
  dpXMLFrmDate!: NgbDateStruct;
  dpXMLToDate!: NgbDateStruct;
  txtUnitNumber: string = '';
  private allRowData: any[] = [];
  date = new Date();

  constructor(
    private apiService: Service,
    private toastr: FCToasterService
  ) { }

  ngOnInit(): void {
    this.gridOptions = {
      defaultColDef: { filter: true, resizable: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32
    };

    this.bindGridOnPageLoad();
    this.bindDefaultValuesOnPageLoad();
  }

  bindGridOnPageLoad() {
    const boolRenderer = (params: any) => {
      const val = params.value;
      if (val === true || val === 1 || val === 'true') {
        return '<span style="color:#1a7a3c;font-weight:600;">Yes</span>';
      } else if (val === false || val === 0 || val === 'false') {
        return '<span style="color:#b91c1c;font-weight:600;">No</span>';
      }
      return '<span style="color:#888;">—</span>';
    };

    this.columnDefs = [
      { headerName: "File Id", field: "fileId", sortable: true, minWidth: 120, flex: 1.2, tooltipField: "fileId", headerTooltip: "File Id" },
      { headerName: "Unit Number", field: "unitNumber", sortable: true, minWidth: 160, flex: 1.6, tooltipField: "unitNumber", headerTooltip: "Unit Number" },
      { headerName: "Upload", field: "isUpload", sortable: true, minWidth: 160, flex: 1.6, headerTooltip: "Upload Status", cellRenderer: boolRenderer },
      { headerName: "Process", field: "isProcess", sortable: true, minWidth: 160, flex: 1.6, headerTooltip: "Process Status", cellRenderer: boolRenderer },
      { headerName: "Message", field: "message", sortable: true, minWidth: 280, flex: 2.8, tooltipField: "message", headerTooltip: "Message" },
      { headerName: "MOD Unit", field: "isXMLModUnit", sortable: true, minWidth: 160, flex: 1.6, headerTooltip: "Is XMLModUnit", cellRenderer: boolRenderer },
      { headerName: "UI Upload", field: "isUiUpload", sortable: true, minWidth: 140, flex: 1.4, headerTooltip: "Is UiUpload", cellRenderer: boolRenderer },
      { headerName: "Created By", field: "createdBy", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "createdBy", headerTooltip: "Created By" },
      { headerName: "Created Date", field: "createdDate", sortable: true, minWidth: 200, flex: 2, tooltipField: "createdDate", headerTooltip: "Created Date" }
    ];
    this.rowData = [];
  }

  bindDefaultValuesOnPageLoad() {
    const dayOfWeek = this.date.getDay(); // 0=Sun, 1=Mon, ...
    const diffToMonday = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
    const startOfWeek = new Date(this.date);
    startOfWeek.setDate(this.date.getDate() + diffToMonday);
    this.dpXMLFrmDate = { year: startOfWeek.getFullYear(), month: startOfWeek.getMonth() + 1, day: startOfWeek.getDate() };
    this.dpXMLToDate = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };
    this.txtUnitNumber = '';
    this.rowData = [];
    this.getGridDataByFilterSearch();
  }

  formatNgbDate(date: NgbDateStruct): string {
    const mm = String(date.month).padStart(2, '0');
    const dd = String(date.day).padStart(2, '0');
    return `${date.year}-${mm}-${dd}`;
  }

  getGridDataByFilterSearch() {
    if (!this.dpXMLFrmDate || !this.dpXMLToDate) {
      this.toastr.showWarning("Please select Start Date and End Date");
      return;
    }

    const fromDate = this.formatNgbDate(this.dpXMLFrmDate);
    const toDate = this.formatNgbDate(this.dpXMLToDate);

    if (fromDate > toDate) {
      this.toastr.showWarning("Start Date must be less than or equal to End Date");
      return;
    }

    this.apiService.getXMLLogs(fromDate, toDate).subscribe((data: any) => {
      this.allRowData = data != null ? data : [];
      this.applyUnitNumberFilter();
    });
  }

  applyUnitNumberFilter() {
    const filter = this.txtUnitNumber ? this.txtUnitNumber.trim().toLowerCase() : '';
    this.rowData = filter
      ? this.allRowData.filter(r => r.unitNumber && r.unitNumber.toString().toLowerCase().includes(filter))
      : [...this.allRowData];
  }

  onUnitNumberFilter() {
    this.applyUnitNumberFilter();
  }

  onResetFilters() {
    this.txtUnitNumber = '';
    this.allRowData = [];
    this.bindDefaultValuesOnPageLoad();
  }

  exportExcel() {
    if (this.rowData != null && this.rowData.length > 0) {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: 'XMLProcessStatus_' + this.formatNgbDate(this.dpXMLFrmDate) + '_To_' + this.formatNgbDate(this.dpXMLToDate)
      };
      this.agGridXmlProcessStatus.api.exportDataAsCsv(params);
    }
  }

  onGridReady(params: any) {
  }
}
